import { ReactElement } from 'react';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth, StyledFlex, TextView } from '@dreryk/react-components';

import { integrationTranslationKeys } from '../../translations';

import { DocplannerUpdateClientSecretConfirmButton } from './DocplannerUpdateClientSecretConfirmButton';
import { DocplannerUpdateClientSecretForm } from './DocplannerUpdateClientSecretForm';

type DocplannerUpdateClientSecretModalProps = {
   readonly apiKey: string;
   readonly onClose: VoidFunction;
};

export const DocplannerUpdateClientSecretModal = (props: DocplannerUpdateClientSecretModalProps): ReactElement => {
   return (
      <Modal
         testId={'updateClientSecretForm'}
         title={integrationTranslationKeys.updateApiSecret}
         width={ModalWidth.NORMAL}
      >
         <StyledFlex direction={'column'} gap={'24px'}>
            <TextView testId={'apiKey'} label={integrationTranslationKeys.apiKey}>
               {props.apiKey}
            </TextView>
            <DocplannerUpdateClientSecretForm>
               {({ handleSubmit, formState, setNewApiSecretError }) => (
                  <>
                     <DocplannerUpdateClientSecretConfirmButton
                        onSuccess={props.onClose}
                        handleSubmit={handleSubmit}
                        setNewApiSecretError={setNewApiSecretError}
                     />
                     <ModalCancelButton shouldConfirmExit={formState.isDirty} onClick={props.onClose} />
                     <ModalCloseButton shouldConfirmExit={formState.isDirty} onClick={props.onClose} />
                  </>
               )}
            </DocplannerUpdateClientSecretForm>
         </StyledFlex>
      </Modal>
   );
};
